var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12V9C10.0016 8.47005 10.2128 7.96227 10.5875 7.58753C10.9623 7.2128 11.4701 7.00158 12 7C12.5299 7.00158 13.0377 7.2128 13.4125 7.58753C13.7872 7.96227 13.9984 8.47005 14 9V12M8 12H16V17H8V12ZM21 14C21 16.3869 20.0518 18.6761 18.364 20.364C16.6761 22.0518 14.3869 23 12 23C9.61305 23 7.32387 22.0518 5.63604 20.364C3.94821 18.6761 3 16.3869 3 14V4L12 2L21 4V14Z",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.c4587750.svg";
export { ForwardRef as ReactComponent };